import { render } from "./BasePending.vue?vue&type=template&id=7d245bd0"
import script from "./BasePending.vue?vue&type=script&lang=js"
export * from "./BasePending.vue?vue&type=script&lang=js"

import "./BasePending.vue?vue&type=style&index=0&id=7d245bd0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__